<template>
	<dynvibebasechart
		:id="axiosComputed"
		ref="basechart"
		@created="chartCreated"
		:functionClick="clickGraph"
		:type="type"
	></dynvibebasechart>
</template>
<script>
import graphMixin from "@/mixins/graphMixin.js";
const moment = require("moment");

function formatter(point, chartOptions) {
	//console.log(point);
	let newValue = point.y;
	let oldValue = chartOptions.series[0].data[point.point.index];

	let evolution = 0;
	if (oldValue === 0) {
		evolution = 100;
		return "";
	} else if (newValue === 0) {
		evolution = -100;
		return "";
	} else {
		evolution = ((newValue - oldValue) / oldValue) * 100;
	}
	evolution = Math.round(evolution);
	//return Highcharts.numberFormat(evolution, 2) + "%";
	let html = '<span class="';
	html += evolution > 0 ? "highchart-growth-up" : "highchart-growth-down";
	html += '">';
	html += evolution > 0 ? "+" : "";
	html += evolution + "%";
	html += "</span";
	return html;
}

export default {
	name: "dynvibecolumn",
	mixins: [graphMixin],
	props: {
		legend: {
			type: Boolean,
			default: false,
		},
		trendfilters: Object,
		semanticfilters: Object,
		displayGrowth: {
			type: Boolean,
			default: false,
		},
		filters: Object,
	},
	data() {
		return {
			modalkeywords: "",
			baseChart: undefined,
		};
	},
	mounted() {
		setTimeout(() => {
			this.baseChart = this.$refs.basechart;
			this.setChartOptions();
		}, 1250);
	},
	methods: {
		setModalKeywords(modalkeywords) {
			this.modalkeywords = modalkeywords;
		},
		setChartOptions() {
			if (!this.baseChart) {
				this.baseChart = this.$refs.basechart;
			}
			if (!this.$refs.basechart) {
				return;
			}

			//let chartOptions = this.$refs.basechart.getChartOptions();
			let chartOptions = this.baseChart.getChartOptions();
			chartOptions.chart.type = "column";
			chartOptions.xAxis.type = "category";

			chartOptions.xAxis.scrollbar = {
				enabled: false,
			};
			chartOptions.xAxis.labels = {
				rotation: 0,
				style: {
					fontSize: "11px",
					fontFamily: "Verdana, sans-serif",
					"text-transform": "uppercase",
				},
			};

			chartOptions.yAxis.labels = {
				style: {
					"font-family": "Verdana, sans-serif",
					"font-size": "11px",
					"font-weight": "400",
					"text-transform": "uppercase",
					color: "#7C7C7C",
				},
			};

			chartOptions.legend = {
				enabled: this.legend,
			};

			chartOptions.plotOptions = {
				bar: {
					stacking: "normal",
					cursor: "pointer",
				},
			};
			if (this.explorePage == true) {
				chartOptions.plotOptions.series = {
					events: {
						click: this.clicked,
					},
				};
			} else if (this.incomingModal == true) {
				chartOptions.plotOptions.series = {
					events: {
						click: this.clickGraph,
					},
				};
			}

			if (this.displayGrowth) {
				chartOptions = this.optionDisplayGrowth(chartOptions);
			}

			this.baseChart.updateChartOptions(chartOptions);
		},
		optionDisplayGrowth(chartOptions) {
			if (this.displayGrowth) {
				chartOptions.tooltip = {
					backgroundColor: null,
					borderWidth: 0,
					shadow: false,
					useHTML: true,
					style: {
						padding: 0,
						zIndex: 100,
					},
				};

				chartOptions.plotOptions.column = {
					dataLabels: {
						enabled: true,
					},
				};

				if (chartOptions.series.length > 0) {
					chartOptions.series[0].dataLabels = {
						enabled: false,
					};

					chartOptions.series[1].dataLabels = {
						enabled: true,
					};
				}
			} else {
				chartOptions.tooltip = {
					backgroundColor: null,
					borderWidth: 0,
					shadow: false,
					useHTML: true,
					style: {
						padding: 0,
					},
				};
				chartOptions.plotOptions.column = {
					dataLabels: {
						enabled: false,
					},
				};
				if (chartOptions.series.length > 0) {
					chartOptions.series[0].dataLabels = {
						enabled: false,
					};
					chartOptions.series[1].dataLabels = {
						enabled: false,
					};
				}
			}

			return chartOptions;
		},
		loadChartData(results) {
			if (!this.baseChart) {
				this.baseChart = this.$refs.basechart;
			}

			let chartOptions = this.$refs.basechart.getChartOptions();
			chartOptions.xAxis.categories = results.categories;
			chartOptions.series = results.values;
			if (results.values.length && results.values[0].data.length === 1) {
				chartOptions.xAxis.max = 0;
				chartOptions.xAxis.scrollbar.enabled = false;
			} else {
				chartOptions.xAxis.max = 15;
				if (results.values.length && results.values[0].data.length <= 15) {
					chartOptions.xAxis.max = results.values[0].data.length - 1;
					chartOptions.xAxis.scrollbar.enabled = false;
					if (typeof results.values[1] !== "undefined" && typeof results.values[1].data !== "undefined") {
						if (results.values[1].data.length > results.values[0].data.length) {
							chartOptions.xAxis.max = results.values[1].data.length - 1;
						}
					}
				} else {
					chartOptions.xAxis.scrollbar.enabled = true;
				}
			}

			if (this.displayGrowth) {
				chartOptions.series[0].dataLabels = {
					enabled: false,
				};

				chartOptions.series[1].dataLabels = {
					enabled: true,
					align: "center",
					useHTML: true,

					formatter: function () {
						return formatter(this, chartOptions);
					},
				};
			}

			this.baseChart.updateChartOptions(chartOptions);
			let noData = true;
			for (let i = 0; i < results.values.length; i++) {
				if (results.values[i].data.length > 0) {
					noData = false;
				}
			}
			this.baseChart.setNoData(noData);
			this.$emit("graphloaded");
		},
		clicked(item) {
			let date = { gte: this.filters.date.gte, lte: this.filters.date.lte };
			if (item.point.series.columnIndex == 0) {
				let gte = moment(this.filters.date.gte);
				let lte = moment(this.filters.date.lte);
				let daysDiff = lte.diff(gte, "days");
				date.lte = gte.subtract(1, "days").format("YYYY-MM-DD");
				date.gte = gte.subtract(daysDiff, "days").format("YYYY-MM-DD");
			}

			this.$emit("clicked", {
				keyword: item.point.category, // Column
				date: date,
			});
		},
	},
	watch: {
		noData: function () {
			if (this.noData == true) this.$emit("graphloaded");
		},
		modalkeywords: function () {
			this.loadComponent();
		},
		displayGrowth: function () {
			let chartOptions = this.baseChart.getChartOptions();
			this.optionDisplayGrowth(chartOptions);
			this.baseChart.updateChartOptions(chartOptions);
		},
		axios: function () {
			this.axiosComputed = this.axios;
			this.$refs.basechart.resetXAxis();
			this.loadComponent();
			this.baseChart.reflow();
		},
	},
};
</script>
<style>
.highcharts-tooltip > span {
	background: rgba(255, 255, 255, 0.85);
	border: 1px solid silver;
	border-radius: 3px;
	box-shadow: 1px 1px 2px #888;
	padding: 8px;
	z-index: 1000;
}

.highchart-growth-up {
	background-color: #23056b;
	color: #fff;
	font-size: 9px;
	padding: 4px;
	position: inherit;
	left: -25px;
	top: -25px;
	z-index: 1;
}

.highchart-growth-down {
	background-color: #fe5c5d;
	color: #fff;
	font-size: 9px;
	padding: 4px;
	position: inherit;
	left: -25px;
	top: -25px;
	z-index: 1;
}
</style>
